export const useRolesStore = defineStore('roles', {
  state: () => ({
    roles: [],
  }),
  actions: {
    setRoles(roles) {
      roles.forEach((role) => {
        role.searchTitle = role.title
          .toLowerCase()
          .replace(/[^a-z0-9#.+]/g, '');
      });

      this.roles = roles;
    },
  },
  getters: {
    rolesInDemand: (state) => state.roles.filter((role) => role.in_demand),
  },
});
